import React from 'react';
import Icon from 'chameleon/packages/blue-book-player/library/icon/Icon';

const NavigatorLegend = ({ showCurrentLegend }) => {
  const LEGEND_TEXT_CLASSES = 'text-[14px] flex items-center';
  return (
    <div
      className="flex flex-row flex-wrap"
      role="region"
      aria-label="Legend for reviewing questions"
    >
      {showCurrentLegend && (
        <div className="flex flex-row mr-[20px]">
          <Icon id="current_question" className="mb-[3px] mr-[7px]" />
          <div className={LEGEND_TEXT_CLASSES}>Current</div>
        </div>
      )}
      <div className="flex flex-row mr-[16px]">
        <div
          role="img"
          aria-label="dashed square border"
          className="w-[16px] h-[16px] inline-block border border-dashed border-bluebook-gray-900 mr-[9px]"
        />
        <div className={LEGEND_TEXT_CLASSES}>Unanswered</div>
      </div>
      <div className="flex flex-row mr-[3px]">
        <Icon
          accessibility={{ altText: 'bookmark icon' }}
          id="for_review"
          className="mr-[7px]"
        />
        <div className={LEGEND_TEXT_CLASSES}>For Review</div>
      </div>
    </div>
  );
};

export default NavigatorLegend;
